import React from "react";
import AppBase from "../../../../theme/src/shared/js/AppBase";

const App = ({ location }) => {
  return (
    <AppBase location={location} isBranchGuide={false} isBusinessGuide={true} />
  );
};

export default App;
